import * as React from "react";
import {RouteComponentProps} from "react-router-dom";
import {useState, useEffect} from "react";
import {connect} from "react-redux";
import ContainerBox from "myshubhlife-component/container-box";
import RoundedButton from "components/roundedButton";
import VerticalDashLine from "consent/utils/verticalDashLine";
import MultiDocUpload from "myshubhlife-component/multiple-doc-upload";
import {uploadKYCDocument} from "documents/actions";
import {getContentType} from "userform/utils";
import {IReduxState} from "reducers";
import Loading from "components/loading";
import {ACCEPT_TYPE} from "utils/variables";
import {currentAddressProofOptions, DocUploadModes, UPLOAD_SIDE} from "Kyc/utils";
import {DocTypes} from "myshubhlife-component/docInput";
import {kycCompleted} from "Kyc/action";
import {docErrors} from "loan-application/application/userInputForm";

interface IConnectProps {
  dispatch?: (action: any) => void;
  userId: number;
  documentUploaded: boolean;
  active: boolean;
  isAndroid: boolean;
  docUploadError: {docType: string; error: string};
}

const KycDocUpload = (props: IConnectProps & RouteComponentProps) => {
  const [errorMsg, setErrorMsg] = useState<string>(null);
  const [isUploaded, setIsUploaded] = useState(false);

  useEffect(() => {
    if (props.docUploadError) {
      const {docType, error} = props.docUploadError;
      setErrorMsg(docErrors.hasOwnProperty(error) ? docErrors[error] : docErrors.DEFAULT);
    }
  }, [props.docUploadError]);

  const docHandleChange = (value: string, name: DocTypes, docSubType: string) => {
    if (name && value) {
      const uploadDocBody = {
         contentType: getContentType(value).mime,
          docSubType,
          userId: props.userId,
          docMode: DocUploadModes.SCAN_UPLOAD,
          docType: name,
          imageB64: value,
      };
      props.dispatch(uploadKYCDocument(name, uploadDocBody));
      setIsUploaded(true);
      setErrorMsg(null);
    }
  };

  const handleOnBtnClick = () => {
    if (props.documentUploaded && isUploaded) {
        props.dispatch(kycCompleted(true));
    } else {
      setErrorMsg("Please upload current address proof to continue the application");
    }
  };
  return(
      <ContainerBox pageTitle="Document Upload" showBackButton={!props.isAndroid}>
        <>
          <Loading active={props.active} />
          <div className="flex-column-center-row">
            <MultiDocUpload
                fileName= {DocTypes.CURRENT_ADDRESS_PROOF}
                primaryLabel={"CURRENT ADDRESS PROOF"}
                secondaryLabel={"Please upload both side"}
                uploadSide= {[UPLOAD_SIDE.FRONT, UPLOAD_SIDE.BACK]}
                getPdfBase64= {docHandleChange}
                docOptions={currentAddressProofOptions}
                isUploaded={props.documentUploaded && isUploaded}
                compressionRequired={true}
                acceptType={`${ACCEPT_TYPE.IMG},${ACCEPT_TYPE.PNG},${ACCEPT_TYPE.JPEG}`}
            />
            <p className="text-danger">{errorMsg}</p>
            <VerticalDashLine dashNumber={2}/>
            <RoundedButton buttonText="Proceed" size="small" onClick={handleOnBtnClick}/>
          </div>
        </>
      </ContainerBox>
  );
};

const mapStateToProps = (state: IReduxState): IConnectProps => {
  return {
      userId: state.login.auth.userId,
      documentUploaded: state.documents.documentUploaded,
      docUploadError: state.documents.docUploadError,
      active: state.documents.active,
      isAndroid: state.login.isAndroid,
  };
};

export default connect<IConnectProps, {}, {}>(mapStateToProps)(KycDocUpload);
